import { render, staticRenderFns } from "./QuickbuyPage.vue?vue&type=template&id=40410045&"
import script from "./QuickbuyPage.vue?vue&type=script&lang=js&"
export * from "./QuickbuyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports